import React, { useState } from 'react';

const App = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className="min-h-screen bg-white text-gray-800 font-sans mt-4">
      

      {/* Hero Section */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-blue-700 z-0"></div>
        <div 
          className="absolute inset-0 z-0 opacity-60 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/cfe5acae34ffbdab5bc97e3179a9d5e5.jpg')`
          }}
        ></div>
        <div className="container mx-auto px-6 py-20 relative z-10">
          <div className="flex flex-col md:flex-row items-center">
            <div className="w-full md:w-1/2 text-white mb-10 md:mb-0">
              <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">Fly Smarter. Fly Protected.</h1>
              <p className="text-xl mb-8">Complete Drone Insurance for Every Flight, Every Mission.</p>
              <p className="mb-8 text-blue-100">At Drone Planet, we understand that drones aren't just equipment—they're essential tools for innovation, precision, and progress. That's why our insurance solutions go beyond basic coverage.</p>
              <div className="flex space-x-4">
                <button className="px-6 py-3 bg-white text-blue-600 font-bold rounded-full hover:bg-blue-50 transition duration-300 cursor-pointer whitespace-nowrap !rounded-button">Get Started</button>
                <button className="px-6 py-3 border-2 border-white text-white font-bold rounded-full hover:bg-white hover:bg-opacity-10 transition duration-300 cursor-pointer whitespace-nowrap !rounded-button">Learn More</button>
              </div>
            </div>
            <div className="w-full md:w-1/2 relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/8d9a6f71e9c010d08b6e4325ae0657dc.jpg" 
                alt="Drone Insurance Platform" 
                className="w-full h-auto object-cover rounded-lg shadow-xl"
              />
              <div className="absolute -bottom-4 -left-4 bg-white p-3 rounded-lg shadow-lg">
                <div className="flex items-center">
                  <div className="w-3 h-3 bg-green-500 rounded-full mr-2"></div>
                  <span className="text-sm font-medium">Instant Coverage</span>
                </div>
              </div>
              <div className="absolute -top-4 -right-4 bg-white p-3 rounded-lg shadow-lg">
                <div className="flex items-center">
                  <div className="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
                  <span className="text-sm font-medium">24/7 Protection</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trusted By Section */}
      <section className="py-10 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-8">
            <p className="text-lg font-medium text-gray-600">Trusted By More Than <span className="text-blue-600 font-bold">+10,000 Users</span></p>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
            <div className="flex items-center text-gray-500">
              <i className="fas fa-building text-xl mr-2"></i>
              <span className="font-medium">AeroCorp</span>
            </div>
            <div className="flex items-center text-gray-500">
              <i className="fas fa-plane text-xl mr-2"></i>
              <span className="font-medium">SkyTech</span>
            </div>
            <div className="flex items-center text-gray-500">
              <i className="fas fa-camera text-xl mr-2"></i>
              <span className="font-medium">DroneFilms</span>
            </div>
            <div className="flex items-center text-gray-500">
              <i className="fas fa-shield-alt text-xl mr-2"></i>
              <span className="font-medium">SecureFlight</span>
            </div>
            <div className="flex items-center text-gray-500">
              <i className="fas fa-map-marker-alt text-xl mr-2"></i>
              <span className="font-medium">MapDrones</span>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Comprehensive Coverage Tailored for You</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Protection that goes beyond basic coverage, ensuring your operations stay seamless, secure, and uninterrupted.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Feature 1 */}
            <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition duration-300">
              <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="fas fa-tools text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">Accidental Damage</h3>
              <p className="text-gray-600">Crashes, technical failures, or weather-related mishaps? We offer fast, hassle-free repairs or replacements.</p>
            </div>

            {/* Feature 2 */}
            <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition duration-300">
              <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="fas fa-gavel text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">Third-Party Liability</h3>
              <p className="text-gray-600">Protection against legal and financial risks if your drone causes injury or property damage.</p>
            </div>

            {/* Feature 3 */}
            <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition duration-300">
              <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="fas fa-route text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">BVLOS & Advanced Ops</h3>
              <p className="text-gray-600">Flying beyond visual line of sight? Our specialized coverage keeps you compliant and confident.</p>
            </div>

            {/* Feature 4 */}
            <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition duration-300">
              <div className="w-14 h-14 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="fas fa-moon text-blue-600 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold mb-3">Night Flights</h3>
              <p className="text-gray-600">Don't let daylight limit your missions. Stay protected around the clock with our night coverage.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row items-center">
            <div className="w-full md:w-1/2 mb-10 md:mb-0">
              <img 
                src="https://public.readdy.ai/ai/img_res/f4a8d2b2e7910107e4f2f9793270493f.jpg" 
                alt="Drone Insurance Benefits" 
                className="w-full h-auto rounded-xl shadow-xl"
              />
            </div>
            <div className="w-full md:w-1/2 md:pl-12">
              <h2 className="text-3xl font-bold mb-6">Why Choose Drone Planet?</h2>
              <div className="space-y-6">
                <div className="flex">
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
                      <i className="fas fa-check text-white text-xs"></i>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-semibold mb-2">Simple, Smart Coverage</h3>
                    <p className="text-gray-600">No confusing jargon—just straightforward, tailored protection that makes sense for your operations.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
                      <i className="fas fa-check text-white text-xs"></i>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-semibold mb-2">Pan-India Protection</h3>
                    <p className="text-gray-600">Coverage that follows you, whether you're flying over urban landscapes or remote terrain.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
                      <i className="fas fa-check text-white text-xs"></i>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-semibold mb-2">Flexible Plans</h3>
                    <p className="text-gray-600">Choose short-term, annual, or project-based insurance to match your specific needs and budget.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center">
                      <i className="fas fa-check text-white text-xs"></i>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-semibold mb-2">Expert Support</h3>
                    <p className="text-gray-600">Get help from real drone insurance specialists—not just a call center. We understand your unique challenges.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Training Support Section */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row-reverse items-center">
            <div className="w-full md:w-1/2 mb-10 md:mb-0 md:pl-12">
              <img 
                src="https://public.readdy.ai/ai/img_res/f9b79bf3b1684587571e87c4a234364e.jpg" 
                alt="Drone Training Support" 
                className="w-full h-auto rounded-xl shadow-xl"
              />
            </div>
            <div className="w-full md:w-1/2 md:pr-12">
              <h2 className="text-3xl font-bold mb-6">Training & RPTO Support</h2>
              <p className="text-gray-600 mb-8">We offer specialized insurance solutions for drone schools, trainees, and Remote Pilot Training Organizations.</p>
              
              <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                      <i className="fas fa-graduation-cap text-blue-600"></i>
                    </div>
                    <div className="ml-4">
                      <h3 className="font-semibold">Training School Coverage</h3>
                      <p className="text-sm text-gray-600">Comprehensive protection for your training facility and equipment</p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-blue-50 p-4 rounded-lg">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                      <i className="fas fa-user-graduate text-blue-600"></i>
                    </div>
                    <div className="ml-4">
                      <h3 className="font-semibold">Student Pilot Insurance</h3>
                      <p className="text-sm text-gray-600">Special rates for trainees learning to fly</p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-blue-50 p-4 rounded-lg">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                      <i className="fas fa-certificate text-blue-600"></i>
                    </div>
                    <div className="ml-4">
                      <h3 className="font-semibold">Certification Support</h3>
                      <p className="text-sm text-gray-600">Insurance solutions that help you meet certification requirements</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <button className="mt-8 px-6 py-3 bg-blue-600 text-white font-bold rounded-full hover:bg-blue-700 transition duration-300 cursor-pointer whitespace-nowrap !rounded-button">Get Training Coverage</button>
            </div>
          </div>
        </div>
      </section>
      <section className="py-20 bg-gradient-to-b from-blue-50 to-gray-50">
  <div className="container mx-auto px-4 md:px-8 text-center">
    <div className="max-w-2xl mx-auto mb-12">
      <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
        Drone Insurance Coverage Comparison
      </h2>
      <p className="text-lg text-gray-600">
        Choose the right protection for your drone operations with our detailed insurance comparison
      </p>
    </div>

    <div className="overflow-x-auto rounded-xl shadow-lg border border-gray-200 bg-white">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-800">
          <tr>
            <th className="px-6 py-5 text-left text-sm font-semibold text-white">
              Coverage Details
            </th>
            <th className="px-6 py-5 text-center text-sm font-semibold text-white bg-blue-500/20">
              Third-Party
              <span className="block text-xs font-normal mt-1">Basic Coverage</span>
            </th>
            <th className="px-6 py-5 text-center text-sm font-semibold text-white bg-green-500/20">
              Comprehensive
              <span className="block text-xs font-normal mt-1">Full Protection</span>
              <span className="inline-block mt-2 px-2 py-1 text-xs font-bold bg-green-500 text-white rounded-full">
                Most Popular
              </span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {[
            ['Third-Party Liability', '✓', '✓'],
            ['Own Damage Coverage', '✕', '✓'],
            ['Theft Protection', '✕', '✓'],
            ['Natural Disasters', '✕', '✓'],
            ['Equipment Replacement', '✕', '✓'],
            ['Payload Coverage', '✕', 'Optional'],
            ['Worldwide Coverage', '✕', '✓'],
            ['Legal Compliance', '✓', '✓'],
            ['Personal Injury', '✓', '✓'],
            ['Data Loss Coverage', '✕', 'Optional'],
          ].map(([feature, thirdParty, comprehensive], index) => (
            <tr key={index} className="hover:bg-gray-50 transition-colors">
              <td className="px-6 py-4 text-sm font-medium text-gray-700">{feature}</td>
              <td className="px-6 py-4 text-center">
                <span className={`text-xl ${thirdParty === '✓' ? 'text-green-500' : 'text-red-500'}`}>
                  {thirdParty}
                </span>
              </td>
              <td className="px-6 py-4 text-center">
                <span className={`text-xl ${comprehensive === '✓' ? 'text-green-500' : 'text-red-500'}`}>
                  {comprehensive}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <div className="mt-8 p-4 bg-blue-50 rounded-lg max-w-3xl mx-auto">
      <h3 className="text-lg font-semibold mb-2 text-gray-800">Key Considerations</h3>
      <ul className="text-sm text-gray-600 list-disc list-inside text-left space-y-2">
        <li>Third-party insurance meets minimum legal requirements for commercial drone operations</li>
        <li>Comprehensive plans typically cost 20-40% more but offer broader protection</li>
        <li>75% of professional operators opt for comprehensive coverage</li>
        <li>Add-ons available for specialized equipment and international operations</li>
      </ul>
    </div>
  </div>
</section>
      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Secure Your Drone. Secure Your Mission.</h2>
          <p className="text-xl mb-10 max-w-3xl mx-auto">Don't wait for an accident to happen. Get insured today and fly with confidence.</p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button 
              className="px-8 py-4 bg-white text-blue-600 font-bold rounded-full hover:bg-blue-50 transition duration-300 cursor-pointer whitespace-nowrap !rounded-button"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              Contact Us Now for a Quote!
              {isHovered && (
                <span className="ml-2 animate-pulse">→</span>
              )}
            </button>
            <button className="px-8 py-4 bg-transparent border-2 border-white text-white font-bold rounded-full hover:bg-white hover:bg-opacity-10 transition duration-300 cursor-pointer whitespace-nowrap !rounded-button">View Coverage Plans</button>
          </div>
        </div>
      </section>

     
    </div>
  );
};

export default App;